<template>
    <div class="admin-dashboard">
      <!-- Welcome Section -->
      <div class="welcome-section" style="display:flex;align-items:center;justify-content:space-between;gap:16px;margin-bottom:24px;padding:20px;background-color:var(--secondary-bg);border-radius:8px;box-shadow:0 2px 8px rgba(0,0,0,0.05);">
        <div style="font-size:1rem;font-weight:600;color:var(--text-primary);white-space:nowrap;">Welcome, {{ userName }}!</div>
        <div class="welcome-actions" style="display:flex;gap:12px;flex-wrap:wrap;">
          <a :href="'/tts'" class="action-link">Online TTS</a>
          <a :href="'/'" class="action-link">返回主页</a>
          <button class="action-btn" @click="showExportDialog = true">导出文章</button>
          <router-link to="/search" class="action-link">搜索文章</router-link>
          <router-link to="/statistics" class="action-link">统计分析</router-link>
          <router-link to="/pipeline" class="action-link ai-pipeline-link">🤖 AI监控</router-link>
          <router-link to="/user-management" class="action-link">用户管理</router-link>
          <router-link to="/logs" class="action-link">日志管理</router-link>
          <button class="action-btn" @click="logexit">注销登录</button>
        </div>
      </div>
  
      <!-- Data Table Section (CRUD) -->
      <div class="data-table-section">
        <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:12px;">
          <h2 style="margin:0;">系统预置源列表</h2>
          <button @click="openAddModal">添加源（管理员权限）</button>
        </div>
        <!-- Data Table -->
        <table class="table table-bordered">
        <thead>
            <tr>
            <th>ID</th>
            <th>Group ID</th>
            <th>Sort ID</th>
            <th>Site URL</th>
            <th>Site Name</th>
            <th>API Host</th>
             <!--<th>Site Icon</th>-->
            <th>Last Update</th>
            <th>Is First</th>
            <th>Total Feed</th>
            <th>Update Interval</th>
            <th>AI Enabled</th>
            <th>Actions</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(node, index) in rssNodes" :key="index">
            <td>{{ node.id }}</td>
            <td>{{ node.groupId }}</td>
            <td>{{ node.sortId }}</td>
            <td>{{ node.siteUrl }}</td>
            <td>{{ node.siteName }}</td>
            <td>{{ node.apiHost }}</td>
            <!--<td>{{ node.siteIcon }}</td>-->
            <td>{{ node.lastUpdate }}</td>
            <td>{{ node.isFirst }}</td>
            <td>{{ node.totalFeed }}</td>
            <td>{{ node.updateInterval }}</td>
            <td>
              <span :class="['ai-badge', node.isAiEnabled === 1 ? 'ai-on' : 'ai-off']">
                {{ node.isAiEnabled === 1 ? '✓ AI' : '—' }}
              </span>
            </td>
            <td>
              <div style="display:flex;gap:8px;flex-wrap:nowrap;">
                <button @click="editRssNode(node)">编辑</button>
                <button @click="deleteEntry(node.id)">删除</button>
              </div>
            </td>
            </tr>
        </tbody>
        </table>

        <!-- Add Modal -->
        <AddRssNode 
        v-if="isModalOpen" 
        :isEditing="isEditing"
        :entity="currentEntity"
        :isVisible="isModalOpen"  
        @addRssNode="addRssNode"
        @updateRssNode="updateRssNode"
        @closeModal="closeModal"/>

      </div>
  
      <!-- Quick Link to AI Pipeline Monitor -->
      <div class="quick-link-card" style="margin-top: 24px; padding: 20px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); border-radius: 12px; display: flex; justify-content: space-between; align-items: center;">
        <div style="color: white;">
          <h3 style="margin: 0 0 4px 0;">🤖 AI Pipeline 监控</h3>
          <p style="margin: 0; opacity: 0.9; font-size: 0.9rem;">查看 AI 评分状态、调用统计和最近处理的文章</p>
        </div>
        <router-link to="/pipeline" style="background: white; color: #667eea; padding: 10px 20px; border-radius: 8px; text-decoration: none; font-weight: 600;">
          进入监控台 →
        </router-link>
      </div>

  

      <!-- 导出对话框 -->
      <div v-if="showExportDialog" class="export-dialog-overlay" @click.self="showExportDialog = false">
        <div class="export-dialog">
          <h3>导出文章</h3>
          <div class="export-form">
            <div class="form-group">
              <label>日期条件</label>
              <select v-model="exportForm.dateOperator">
                <option value=">=">大于等于</option>
                <option value="<=">小于等于</option>
                <option value="=">等于</option>
                <option value="between">时间段</option>
              </select>
              <input type="date" v-model="exportForm.date" v-if="exportForm.dateOperator !== 'between'" />
              <div v-else class="date-range">
                <input type="date" v-model="exportForm.startDate" />
                <span>至</span>
                <input type="date" v-model="exportForm.endDate" />
              </div>
            </div>
            
            <div class="form-group">
              <label>RSS节点</label>
              <select v-model="exportForm.rssNodeId">
                <option value="">全部</option>
                <option v-for="node in rssNodes" :key="node.id" :value="node.id">
                  {{ node.siteName }}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label>限制数量</label>
              <input type="number" v-model="exportForm.limit" min="1" placeholder="不限制则留空" />
            </div>

            <div class="form-actions">
              <button @click="exportArticles" :disabled="isExporting">导出</button>
              <button @click="showExportDialog = false">取消</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  
</template>
  
  
<script src="./AdminDashboard.js"></script>
  
<style scoped>

.admin-dashboard {
  padding: 24px;
  font-size: 0.875rem;
  line-height: 1.6;
  background-color: var(--primary-bg);
  min-height: 100vh;
}

.welcome-section {
  margin-bottom: 24px;
  padding: 20px;
  background-color: var(--secondary-bg);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.welcome-section h6 {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 16px;
  color: var(--text-primary);
}

.welcome-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.action-link {
  padding: 6px 12px;
  background-color: var(--accent-color);
  color: white;
  text-decoration: none;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.action-link:hover {
  background-color: var(--text-primary);
}

.action-btn {
  padding: 6px 12px;
  background-color: var(--accent-color);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.action-btn:hover {
  background-color: var(--text-primary);
}

.data-table-section, .statistics-section {
  margin-bottom: 30px;
  padding: 20px;
  background-color: var(--secondary-bg);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.data-table-section h2, .statistics-section h2 {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 20px;
  color: var(--text-primary);
}

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
  line-height: 1.6;
  background-color: var(--secondary-bg);
  margin-bottom: 16px;
}

th, td {
  border: 1px solid var(--border-color);
  padding: 12px;
  text-align: left;
}

th {
  font-weight: 600;
  background-color: var(--hover-bg);
  color: var(--text-primary);
}

tr:hover {
  background-color: var(--hover-bg);
}

button {
  margin-right: 8px;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.6;
  padding: 6px 12px;
  background-color: var(--accent-color);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

button:hover {
  background-color: var(--text-primary);
}

.modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: var(--secondary-bg);
  padding: 24px;
  width: 400px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  z-index: 1000;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 999;
}

/* 分页控件样式 */
.pagination-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 16px;
  padding: 8px;
}

.pagination-controls button {
  padding: 6px 12px;
  background-color: var(--accent-color);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.pagination-controls button:hover:not(:disabled) {
  background-color: var(--text-primary);
}

.pagination-controls button:disabled {
  background-color: var(--border-color);
  cursor: not-allowed;
}

/* 加载动画样式 */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid var(--border-color);
  border-top: 4px solid var(--accent-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.export-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.export-dialog {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 400px;
  max-width: 90%;
}

.export-dialog h3 {
  margin-top: 0;
  margin-bottom: 20px;
}

.export-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.form-group label {
  font-weight: 500;
}

.form-group select,
.form-group input {
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.date-range {
  display: flex;
  align-items: center;
  gap: 10px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.form-actions button {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.form-actions button:first-child {
  background-color: #4CAF50;
  color: white;
}

.form-actions button:last-child {
  background-color: #f44336;
  color: white;
}

.export-btn {
  padding: 8px 16px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.ai-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
}

.ai-on {
  background-color: #d4edda;
  color: #155724;
}

.ai-off {
  background-color: #f8f9fa;
  color: #6c757d;
}

/* Pipeline Monitor Styles */
.pipeline-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 12px;
}

.status-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 16px;
  border-radius: 8px;
  text-align: center;
}

.status-card .status-label {
  font-size: 0.75rem;
  opacity: 0.9;
  margin-bottom: 4px;
}

.status-card .status-count {
  font-size: 1.5rem;
  font-weight: 700;
}

.ai-nodes-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.ai-node-tag {
  display: inline-block;
  padding: 4px 10px;
  background-color: #e3f2fd;
  color: #1565c0;
  border-radius: 16px;
  font-size: 0.8rem;
}

.score-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: 600;
}

.score-high {
  background-color: #d4edda;
  color: #155724;
}

.score-low {
  background-color: #f8d7da;
  color: #721c24;
}

.status-mini {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 0.7rem;
}

.status-100 { background: #d4edda; color: #155724; }
.status-99 { background: #f8d7da; color: #721c24; }
.status-20 { background: #fff3cd; color: #856404; }
.status-10 { background: #cce5ff; color: #004085; }
.status-0 { background: #e2e3e5; color: #383d41; }
.status--1 { background: #f5f5f5; color: #999; }

/* AI Stats Cards */
.ai-stats-cards {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.ai-stat-card {
  display: flex;
  align-items: center;
  gap: 12px;
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
  color: white;
  padding: 16px 24px;
  border-radius: 12px;
  min-width: 160px;
  box-shadow: 0 4px 12px rgba(17, 153, 142, 0.3);
}

.ai-stat-icon {
  font-size: 2rem;
}

.ai-stat-content {
  display: flex;
  flex-direction: column;
}

.ai-stat-value {
  font-size: 1.8rem;
  font-weight: 700;
  line-height: 1;
}

.ai-stat-label {
  font-size: 0.75rem;
  opacity: 0.9;
  margin-top: 4px;
}

</style>
  